import * as constants from './constants';

const initialState = {
  allNpoStatuses: [],
  fetchingLoading: true,
  updateLoading: false,
  totalRecords: 0,
  isAdding: false,
};

const npoStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.CREATE_NPO_STATUSES:
      return {
        ...state,
        updateLoading: true,
      };
    case constants.CREATE_NPO_STATUSES_SUCCESS:
      return {
        ...state,
        updateLoading: false,
        allNpoStatuses: [...state.allNpoStatuses, action.data],
        isAdding: false,
      };
    case constants.CREATE_NPO_STATUSES_ERROR:
      return {
        ...state,
        updateLoading: false,
        isAdding: false,
      };

    case constants.UPDATE_ORDER_NPO_STATUS:
      return {
        ...state,
        fetchingLoading: true,
      };
    case constants.UPDATE_ORDER_NPO_STATUS_SUCCESS:
      return {
        ...state,
        fetchingLoading: false,
        allNpoStatuses: action.data,
      };
    case constants.UPDATE_ORDER_NPO_STATUS_ERROR:
      return {
        ...state,
        fetchingLoading: false,
      };

    case constants.FETCH_NPO_STATUSES:
      return {
        ...state,
        fetchingLoading: true,
      };
    case constants.FETCH_NPO_STATUSES_SUCCESS:
      return {
        ...state,
        fetchingLoading: false,
        allNpoStatuses: action.data,
        isAdding: false,
      };
    case constants.FETCH_NPO_STATUSES_ERROR:
      return {
        ...state,
        fetchingLoading: false,
        isAdding: false,
      };
    case constants.UPDATE_NPO_STATUSES:
      return {
        ...state,
        updateLoading: true,
      };
    case constants.UPDATE_NPO_STATUSES_SUCCESS:
      const updated = state.allNpoStatuses.map((el) =>
        el.id === action.data.id ? { ...el, ...action.data } : el
      );
      return {
        ...state,
        allNpoStatuses: updated,
        updateLoading: false,
        isAdding: false,
      };
    case constants.UPDATE_NPO_STATUSES_ERROR:
      return {
        ...state,
        updateLoading: false,
        isAdding: false,
      };
    case constants.DELETE_NPO_STATUSES:
      return {
        ...state,
        updateLoading: true,
        isAdding: false,
      };
    case constants.DELETE_NPO_STATUSES_SUCCESS:
      const updatedData = state.allNpoStatuses.filter(
        (el) => el.id !== action.data
      );
      return {
        ...state,
        allNpoStatuses: updatedData,
        updateLoading: false,
        isAdding: false,
      };
    case constants.DELETE_NPO_STATUSES_ERROR:
      return {
        ...state,
        updateLoading: false,
        isAdding: false,
      };
    case constants.IS_ADDING_UPDATE:
      return {
        ...state,
        isAdding: action.data,
      };

    default:
      return state;
  }
};

export default npoStatusReducer;
